import { fromJsonArray } from 'src/core/utils';

export interface Sort {
    sorted: boolean;
    unsortable: boolean;
    empty: boolean;
}

export type SortDirection = 'asc' | 'desc';

export interface PageableQueryParams {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: SortDirection;
    filter?: string;
}
export default class Pageable<T> {
    public readonly items: T[];

    public readonly sort: Sort;

    public readonly totalPages: number;

    public readonly totalElements: number;

    public readonly page: number;

    public readonly numberOfElements: number;

    public readonly pageSize: number;

    public readonly first: boolean;

    public readonly last: boolean;

    public readonly empty: boolean;

    constructor(constructor: new (json: any) => T, json: Record<string, any>) {
        this.items = fromJsonArray(constructor, json.content);

        this.sort = json.sort;
        this.totalElements = json.totalElements;
        this.totalPages = json.totalPages;
        this.page = json.number;
        this.numberOfElements = json.numberOfElements;
        this.pageSize = json.size;
        this.first = json.first;
        this.last = json.last;
        this.empty = json.empty;
    }

    getQueryParams(params: PageableQueryParams = {}): PageableQueryParams {
        return {
            pageSize: this.pageSize,
            page: this.page,
            ...params,
        };
    }
}
